import { authProviderDefaults, IntentsAuthProvider } from '@40seas/payments-shared';
import { AxiosInstance } from 'axios';
import useInitDataProviderParams from '../../../../../hooks/useInitDataProviderParams';
import { IntentData } from '../types';

export const useDashboardIntentsAuthProvider = (data?: IntentData): IntentsAuthProvider => {
    const { getHeaders } = useInitDataProviderParams();

    const { updateToken, addBearer, setInterceptors } = authProviderDefaults;

    if (!data) return { bootstrap: (axios) => Promise.resolve(axios), updateToken, addBearer, setInterceptors };

    const tenantHeaders = data.tenant ? { '40seas-tenant': data.tenant } : undefined;

    return {
        async bootstrap(axios: AxiosInstance): Promise<AxiosInstance> {
            const authHeaders = await getHeaders();

            Object.entries({
                ...authHeaders,
                ...tenantHeaders,
                ...(data.token ? { '40seas-token': data.token } : {}),
            }).forEach(([key, value]) => {
                if (value !== undefined) {
                    axios.defaults.headers[key] = value as string;
                }
            });

            return axios;
        },
        updateToken,
        addBearer,
        setInterceptors,
    };
};
